const zIndex = {
  min: 1,
  backdrop: 1,
  balloonCloseButton: 1,
  liveAgent: 1,
  checkAvailability: 2,
  balloon: 2,
  offerFilters: 2,
  galleryScrollButton: 2,
  floatingBookmarkButton: 3,
  balloonArrow: 3,
  searchLocationSuggestions: 4,
  searchMenu: 5,
  bookingSidebar: 5,
  stickySocialWidget: 9,
  stickySubscription: 10,
  tooltip: 10,
  stickyFooter: 20,
  stickySubHeader: 99,
  stickyPromptCard: 100,
  stickyHeader: 101,
  menu: 102,
  subHeader: 103,
  floatingPanel: 104,
  header: 104,
  notification: 105,
  spoofingWarning: 299,
  modal: 300,
  offerFiltersOpen: 301,
  offerFilterPointer: 302,
  payPalSplitBill: 303,
}

export default zIndex
